/*
  環境変数定義（本番サーバー用）
  © 2021 Digital Information Technologies Corporation. All Rights Reserved.
  @author Digital Information Technologies Corporation
  @module src/constants/sysconfig.real.ts
*/

/*
  環境変数定義（本番サーバー用）
  環境固有の環境変数を定義する。
  当ファイルの定義値で、sysconfig.tsを上書きする。
  @class src:constants:sysconfig.real
  @static
*/

const sysconfig = {
  // 共通
  common: {
    // 開発モード
    devmode: false,
  },

  analysis: {
    endpointUrl: "https://bgdlaoivq5.execute-api.ap-northeast-1.amazonaws.com",
    envPath: "prod",
    oldAnalysisApiUse: false,
  },

  // ３分初期作成業種切替
  siteinit: {
    // 旧業種を利用する代理店
    oldBizCat: {
      shopcodes: [
        "0003", // 株式会社LIXIL住生活ソリューション
        "0005", // GoodLiving友の会
        "0008", // ホームページ作成パッケージ
        "0042", // キヤノンマーケティングジャパン株式会社
        "0086", // アイ・モバイル株式会社 スタッフアカウント
        "0087", // アイ・モバイル株式会社 社内共有・サンプルサイト
        "0097", // アイ・モバイル システム開発部
        "0099", // アイ・モバイル株式会社 テンプレート管理
      ],
    },
  },

  logs: {
    endpointUrl: "https://n0yl5yzp2e.execute-api.ap-northeast-1.amazonaws.com",
    envPath: "prod",
    oldAnalysisApiUse: true,
    openKey: "im",
  },

  recommend: {
    endpointUrl: "/support/recommend",
  },

  profile: {
    endpointUrl: "/support/profilesetting",
  },

  // 業種別化粧
  makeupTargetIndustry: {
    targetClientCode: [
      "1003", // 建設・建築・土木業
      "1004", // 製造業
      "1015", // 介護業・福祉業
    ],
    targetClientName: {
      1003: "common_code_member_industry_construction", // 建設・建築・土木業
      1004: "common_code_common_industry_manufacturing", // 製造業
      1015: "common_code_member_industry_nursingCareAndWelfare", // 介護業・福祉業
    },
  },

  // Google Analyticsの設定
  googleAnalytics: {
    // Google AnalyticsのトラッキングID
    trackingId: "G-RG2VDM5DNN",
  },
};

export default sysconfig;
